import {
  clearIABudgetInfo,
  clearNewTrackingAction,
  setIABudgetInfo,
  setNewTrackingAction,
} from "./ActionsCreators";

export const setIABudget = (data) => {
  return (dispatch) => {
    dispatch(setIABudgetInfo(data));
  };
};

export const clearIABudget = () => {
  return (dispatch) => {
    dispatch(clearIABudgetInfo());
  };
};

export const setNewTracking = (data) => {
  return (dispatch) => {
    dispatch(setNewTrackingAction(data));
  };
};

export const clearNewTracking = () => {
  return (dispatch) => {
    dispatch(clearNewTrackingAction());
  };
};
